<h2 mat-dialog-title>Dados do pagamento</h2>
<mat-dialog-content class="mat-typography payment-dialog-content">
  <mat-tab-group>
    <mat-tab label="Pagamento">
      <div class="loading-state" *ngIf="loadingPayment">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
      <page-alert [message]="errorMessage" *ngIf="errorMessage" alertClass="alert-danger"></page-alert>
      <div class="payment-lookup-actions" *ngIf="paymentLookupFailed && !loadingPayment">
        <button mat-stroked-button color="primary" type="button" (click)="retryPaymentLookup()">Tentar novamente</button>
      </div>
      <mat-card-content *ngIf="exibitionMode == 'VIEW'">
        <div class="info">
          <div class="row">
            <div class="col-md-4 col-lg-2">Procedimento:</div>
            <div class="col-md-8 col-lg-10">{{ paymentData.healthcareservice_name }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-2">Especialista:</div>
            <div class="col-md-8 col-lg-10">{{ encounter.practitioner?.name }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-2">Clínica:</div>
            <div class="col-md-8 col-lg-10">{{ encounter.organization?.name }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-2">Valor:</div>
            <div class="col-md-8 col-lg-10">{{ formatPaymentValue(paymentData.value) }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-2">Forma de pagamento:</div>
            <div class="col-md-8 col-lg-10">{{ getPaymentType(paymentData.billingType || '') }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-2">Status de Pagamento:</div>
            <div class="col-md-8 col-lg-10 payment-status">
              <span [ngClass]="getColorStatus(paymentData.status || '')"> {{ getStatusPayment(paymentData.status || '') }}</span>
              <span class="payment-status-check-inline" *ngIf="checkingPaymentStatus">Verificando pagamento...</span>
            </div>
          </div>
          <div class="row" *ngIf="paymentData.status_reason">
            <div class="col-md-4 col-lg-2">Motivo:</div>
            <div class="col-md-8 col-lg-10">{{ paymentData.status_reason }}</div>
          </div>
          <div class="row" *ngIf="getPaymentStatusHelp()">
            <div class="col-md-4 col-lg-2">Detalhe:</div>
            <div class="col-md-8 col-lg-10">{{ getPaymentStatusHelp() }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-2">Data de Pagamento:</div>
            <div class="col-md-8 col-lg-10">
              {{
                paymentData.confirmed_at || paymentData.payment_at ? (paymentData.confirmed_at || paymentData.payment_at | date: 'dd/MM/yyyy') : '-'
              }}
            </div>
          </div>
          <div class="row" *ngIf="paymentData.expires_at || paymentData.due_at">
            <div class="col-md-4 col-lg-2">Expira em:</div>
            <div class="col-md-8 col-lg-10">{{ paymentData.expires_at || paymentData.due_at | date: 'dd/MM/yyyy HH:mm' }}</div>
          </div>
          <div class="payment-actions" *ngIf="canRetryPayment()">
            <button mat-flat-button color="primary" type="button" (click)="retryPayment()">Gerar outro pagamento</button>
          </div>
        </div>
      </mat-card-content>

      <div class="pix-container" *ngIf="shouldShowPixQrCode()">
        <mat-card class="pix-card">
          <h2>Pagamento via PIX</h2>
          <qrcode [qrdata]="qrData" [width]="350" [errorCorrectionLevel]="'M'"></qrcode>
          <p *ngIf="paymentData.expires_at || paymentData.due_at">
            Valido ate {{ paymentData.expires_at || paymentData.due_at | date: 'dd/MM/yyyy HH:mm' }}
          </p>
          <p class="payment-status-check" *ngIf="checkingPaymentStatus">Verificando pagamento...</p>
          <button style="cursor: pointer; margin-bottom: 4rem" mat-raised-button color="primary" (click)="copiarPix()">PIX Copia e Cola</button>
        </mat-card>
      </div>

      <div class="payment-create-area" *ngIf="paymentMethod === 'PIX' && exibitionMode == 'CREATE'">
        <src-payment-pix [encounter]="encounter" [forceNew]="forceNewPayment" (onConfirmPayment)="onConfirmPayment($event)"></src-payment-pix>
      </div>
      <div class="payment-create-area" *ngIf="paymentMethod === 'CREDIT_CARD' && exibitionMode == 'CREATE'">
        <src-payment-credit-card
          [encounter]="encounter"
          [forceNew]="forceNewPayment"
          (onConfirmPayment)="onConfirmPayment($event)"
        ></src-payment-credit-card>
      </div>
      <div class="payment-create-area" *ngIf="paymentMethod === 'PHYSICAL' && exibitionMode == 'CREATE'">
        <src-payment-physical [encounter]="encounter" (onConfirmPayment)="onConfirmPayment($event)"></src-payment-physical>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
